import { useState } from 'react';

interface BrandLogoProps {
  logoUrl?: string;
  logoGrad: string;
  logoIcon: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  rounded?: string;
}

export default function BrandLogo({ logoUrl, logoGrad, logoIcon, name, size = 'md', rounded }: BrandLogoProps) {
  const [imgSrc, setImgSrc] = useState<string | null>(logoUrl ?? null);
  const [failed, setFailed] = useState(false);

  const sizeClass = size === 'sm' ? 'w-10 h-10' : size === 'lg' ? 'w-16 h-16' : 'w-12 h-12';
  const iconClass = size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-2xl' : 'text-xl';
  const padding = size === 'lg' ? 'p-1.5' : 'p-1';
  const roundedClass = rounded ?? 'rounded-xl';

  const handleError = () => {
    // If currently showing an icon.horse URL, try DuckDuckGo as fallback
    if (imgSrc && imgSrc.includes('icon.horse/icon/')) {
      const domain = imgSrc.replace('https://icon.horse/icon/', '').replace('http://icon.horse/icon/', '');
      const ddgUrl = `https://icons.duckduckgo.com/ip3/${domain}.ico`;
      setImgSrc(ddgUrl);
      return;
    }
    // If DuckDuckGo also fails, try Google gstatic favicon
    if (imgSrc && imgSrc.includes('duckduckgo.com')) {
      const match = imgSrc.match(/ip3\/(.+)\.ico/);
      if (match) {
        const domain = match[1];
        const gstaticUrl = `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${domain}&size=256`;
        setImgSrc(gstaticUrl);
        return;
      }
    }
    // All sources failed — show gradient fallback
    setFailed(true);
  };

  if (imgSrc && !failed) {
    return (
      <div className={`${sizeClass} flex-shrink-0 ${roundedClass} bg-white border border-gray-100 overflow-hidden flex items-center justify-center ${padding}`}>
        <img
          src={imgSrc}
          alt={name}
          className="w-full h-full object-contain"
          onError={handleError}
        />
      </div>
    );
  }

  return (
    <div className={`${sizeClass} flex items-center justify-center flex-shrink-0 ${roundedClass} bg-gradient-to-br ${logoGrad}`}>
      <i className={`${logoIcon} text-white ${iconClass}`}></i>
    </div>
  );
}
